import { useEffect } from 'react';

export const useOutsideClick = (ref: any, onClickOut: () => void) => {
  useEffect(() => {
    const onClick = ({ target }: any) => !ref?.contains(target) && onClickOut?.();
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [ref]);
};
